import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import * as types from "../../constants/actionTypes";

import FindCareForm from "./FindCareForm";
import FindCareResults from "./FindCareResults";

import SectionLoadingError from "../common/SectionLoadingError";
import COVIDScreeningModal from "../common/COVIDScreeningModal";

import Spinner from "../common/spinner";
import * as queryString from 'query-string';

import { getMapListOfLocations, getMapListOfProviders, groupByLocation } from './mapList';
import { logUI } from '../../api/andyliticsApi';
import * as Tools from "../../helpers/Tools";
import { queryParams } from "../../helpers/formatting";
import { getValue } from "../../helpers/data";
import Cookies from "cookies-js";
import * as d from "../../reducers/domainReducer";
import { CovidScreeningModalSessionKeyInitial, MammogramCovid19ModalSessionKeyInitial } from "../../constants/textConstants";
import NotAuthorized from "../common/NotAuthorized";
import { Grid, Typography } from "../ecosystem/";
import { PageHeading } from "../ecosystem/mybswh";
import * as msgs from "../../constants/textConstants";

const USE_CURRENT_LOCATION = 'Current Location';
const USE_MAPPED_AREA_LOCATION = 'Mapped Area';

/*
 * Container component for the FindCare page.
 * 
 */
class FindCare extends React.Component {
    constructor(props, context) {
        super(props, context);

        const { location, searchModel, locationsSearchModel, clearSearch, getGeoLocation, hasAAL, serverData, cityAddress, stateAddress, waitingOnGeoAddress } = this.props;
        const searchParams = location.search ? queryString.parse(location.search)
            : location.searchParms ? queryString.parse(location.searchParms) : null;
        const isUrgentCare = getValue('isUrgentCare', clearSearch && !searchParams, '', searchParams);

        // const isMammoCare = getValue('isMammoCare', clearSearch && !searchParams, '', searchParams);

        const scheduleCampaignReferrer = this.props.location && this.props.location.state && this.props.location.state.scheduleCampaignReferrer;

        let urgentCareModel = null;

        const isVaccineSearch = this.isVaccineCheck();

        if (searchParams !== null && searchParams.location) {
            this.setLocationInCaseOfLatLng(searchParams);
        }

        //Setting the model if its from urgent care.
        if (isUrgentCare) {
            const { serverData } = this.props;
            urgentCareModel = { //TODO, we can remove below server data if not required to maintain in config.
                keyword: serverData.sameDayCareKeyword ? serverData.sameDayCareKeyword : "urgent care",
                vector: serverData.sameDayCareVector ? serverData.sameDayCareVector : "clinicalTerm",
                // visitType: serverData.sameDayCareVisitType ? serverData.sameDayCareVisitType : "New Patient",
                //  locationType: serverData.sameDayCareLocationType ? serverData.sameDayCareLocationType : "Clinic/Physician Office",
                location: getValue('location', false, USE_CURRENT_LOCATION, searchParams)
                //availability: serverData.sameDayCareAvailability ? serverData.sameDayCareAvailability : "3",
                //locPerks: serverData.sameDayCareLocationPerks ? serverData.sameDayCareLocationPerks : "Accepts Walk-ins",                
                //usesMyBSWHealth: serverData.sameDayCareUsesMyBSWHealth ? serverData.sameDayCareUsesMyBSWHealth : true,
                //sortBy: serverData.sameDayCareSortBy ? serverData.sameDayCareSortBy : "NextAvailableAppointment",
                //locationSortBy: serverData.sameDayCareLocationSortBy ? serverData.sameDayCareLocationSortBy : "Distance",

            };
            this.setZoom(false);
        }

        //if (isMammoCare) {
        //    const { serverData } = this.props;
        //    const mammographySearchTerms = this.splitMammographySearchTerms(serverData.MammographySearchTerms);
        //     //&#x27; is Hex code of Apostrophe
        //    mammoCareModel = {
        //        keyword: serverData.sameDayCareKeyword ? serverData.sameDayCareKeyword : mammographySearchTerms[0].replaceAll('&#x27;', '\'').toString()
        //                                               ? serverData.sameDayCareKeyword : mammographySearchTerms[1].replaceAll('&#x27;', '\'').toString()
        //                                               ? serverData.sameDayCareKeyword : mammographySearchTerms[2].replaceAll('&#x27;', '\'').toString()
        //                                               ? serverData.sameDayCareKeyword : mammographySearchTerms[3].replaceAll('&#x27;', '\'').toString()
        //                                               ? serverData.sameDayCareKeyword : mammographySearchTerms[4].replaceAll('&#x27;', '\'').toString(),
        //        vector: serverData.sameDayCareVector ? serverData.sameDayCareVector : "clinicalTerm",
        //        location: getValue('location', false, USE_CURRENT_LOCATION, searchParams)
        //    };
        //    this.setZoom(false);
        //}

        const kwd = getValue('keyword', !searchParams, '', urgentCareModel, searchParams, searchModel);
        let loc = getValue('location', !searchParams, USE_CURRENT_LOCATION, urgentCareModel, searchParams, searchModel);
        let ins = getValue('insurance', !searchParams, '', urgentCareModel, searchParams, searchModel);
        const insuranceFromStorage = Tools.getItemFromSessionStorage('insurance_' + this.props.userName);
        this.acoAlliance = this.getAcoAlliance();
        let acoLabel = "";
        if (!ins) {
            if (typeof window !== "undefined" && insuranceFromStorage !== null) {
                ins = insuranceFromStorage;
            } else {
                if (hasAAL && serverData && serverData.enableAA)
                    ins = this.props.insuranceName;
                else if (this.props.healthPlanId !== "") {
                    ins = insuranceFromStorage !== null ? insuranceFromStorage : this.props.insuranceName;
                } else {
                    if (this.acoAlliance) {
                        let acoFirstItem = this.acoAlliance.split(',')[0];
                        const matchingACO = Tools.getACOs().find(a => a.id === acoFirstItem); //check if exists in our static ACOs list.    
                        if (matchingACO) {
                            ins = acoLabel = matchingACO.label;
                        }
                    }
                }
            }
        }

        if (searchModel) {
            searchModel.vector = searchModel.vectorName;
            searchModel.insurance = searchModel.insuranceCarrier;
        }

        /*if (loc === USE_CURRENT_LOCATION) {
            getGeoLocation(false);
        }*/

        //we will clean up this condition, once we done the state reset user story.
        this.setLocationInCaseOfLatLng(searchModel);

        const locationFromStorage = Cookies.get('location_' + this.props.userName);
        this.isCurrentGeoLoc = false;

        //Setting up location 
        const geoAddr = !waitingOnGeoAddress && cityAddress && stateAddress ? `${cityAddress},${stateAddress}` : loc

        // check if flow reaches here from VideoVisit.js (Find a new doctor Link).
        const findNewDoctor = this.props && this.props.history && this.props.history.location && this.props.history.location.state && this.props.history.location.state.findNewDoctor ? this.props.history.location.state.findNewDoctor : false;
        // check if flow reaches here from SelectDoctor Page from appointments
        const seeAllYourDoctors = this.props && this.props.history && this.props.history.location && this.props.history.location.state && this.props.history.location.state.seeAllYourDoctors ? this.props.history.location.state.seeAllYourDoctors : false;

        const cityZipLoc = (searchParams && (searchParams.location || searchParams.location === '') && !isUrgentCare) ? searchParams.location : (isUrgentCare && locationFromStorage === "")
            ? geoAddr : (locationFromStorage !== null && locationFromStorage !== undefined) ? locationFromStorage : this.props.isCurrentLocation ? USE_CURRENT_LOCATION : geoAddr;

        const vaccineSearchOnMount = cityZipLoc !== "" ? (cityZipLoc === USE_CURRENT_LOCATION ? this.props.latitude && this.props.longitude : true) : true;

        this.state = {
            keyword: kwd,
            keywordList: [],
            insurance: isVaccineSearch ? "" : ins,
            cityZip: cityZipLoc,
            vector: getValue('vector', !searchParams, 'unified', searchParams, isUrgentCare ? urgentCareModel : searchModel), //some reason searchModel is holding vector as unified even if it is urgent care. so using urgentCareModel.            
            networkCode: getValue('networkCode', clearSearch || isUrgentCare, '', searchModel, this.props),
            hasExtendedHours: false,
            allowsWalkIns: false,
            returnMobileModel: true,
            lob: 'BSWH',
            pageNumber: getValue('pageNumber', clearSearch || isUrgentCare, 1, searchModel),
            perPage: getValue('perPage', clearSearch || isUrgentCare, 12, searchModel),
            totalPages: 1,
            pageNumberLocations: getValue('pageNumber', clearSearch || isUrgentCare, 1, locationsSearchModel),
            perPageLocations: getValue('perPage', clearSearch || isUrgentCare, 12, locationsSearchModel),
            totalPagesLocations: 1,
            sortSeed: Math.floor(Math.random() * 10000),
            sortSeedLocations: Math.floor(Math.random() * 10000),
            sortUpdated: false,
            searchOnMount: isVaccineSearch ? vaccineSearchOnMount : (findNewDoctor || seeAllYourDoctors || kwd !== "" || (loc !== "" && loc !== USE_CURRENT_LOCATION)) && this.acoAlliance !== null,
            searchParams: searchParams,
            mapList: null,
            availability: getValue('availability', clearSearch, '0', urgentCareModel, searchParams, searchModel),
            urgentCareModel: urgentCareModel,
            clearFilters: false,
            activeTab: getValue('tab', !searchParams, '1', searchParams, searchModel),
            //acoAlliance: this.props.acoList.length > 0 ? this.props.acoList[0] : "",         // TODO: for now, just use the first item in the list, per Jason. Work out the ui to select one later.
            selectedAco: acoLabel,
            mappedAreaLocation: (searchParams && searchParams.isMappedArea && searchParams.location && searchParams.location.split(',').length === 2 && searchParams.location.split(',')[0].indexOf('.') !== -1 && searchParams.location.split(',')[1].indexOf('.') !== -1) ? { latitude: searchParams.location.split(',')[0], longitude: searchParams.location.split(',')[1] } : null,
            radius: isVaccineSearch ? (searchParams && searchParams.distance ? searchParams.distance : '25') : null,
            isMappedArea: (searchParams && searchParams.isMappedArea) ? searchParams.isMappedArea : null, //loc === 'Mapped Area'
            overrideRules: false, //disable override by default.
            mainSearch: true,
            searchForVideoVisit: findNewDoctor || seeAllYourDoctors,  // enable Video Visit type when find a new doctor link is clicked from VideoVisit.js/ or See all your doctors from Select Doctor.            
            isVaccineSearch: this.isVaccineCheck(),
            scheduleCampaignReferrer: scheduleCampaignReferrer,
        };

        // special case: in-person vector from the route parameter requires the following:

        this.searchProviders = this.searchProviders.bind(this);
        this.searchLocations = this.searchLocations.bind(this);
        this.searchProvidersAndLocations = this.searchProvidersAndLocations.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.nextPageLocations = this.nextPageLocations.bind(this);
        this.applyFilters = this.applyFilters.bind(this);
        this.onSearchProvidersComplete = this.onSearchProvidersComplete.bind(this);
        this.getMappedAreaSearchResults = this.getMappedAreaSearchResults.bind(this);
        this.resetRadius = this.resetRadius.bind(this);
        this.isLatLongInLocation = this.isLatLongInLocation.bind(this);
    }

    componentDidMount() {
        const { hasAAL, serverData, cityAddress, stateAddress, waitingOnGeoAddress, isCovidVaxScheduleEligible, enableCovidScheduleAuthFeature, currentUser } = this.props;
        this.historyUnlisten = this.props.history.listen((location, action) => {
            const { selectedAco } = this.state;
            const searchParams = location.search ? queryString.parse(location.search)
                : location.searchParms ? queryString.parse(location.searchParms) : null;
            if (location.pathname.toLowerCase() === '/findcare') {
                const insuranceFromStorage = Tools.getItemFromSessionStorage('insurance_' + this.props.userName);
                const insurance = insuranceFromStorage !== null
                    ? insuranceFromStorage
                    : hasAAL ? serverData.aaInsuranceCarrier : this.props.healthPlanId !== "" && selectedAco === "" ? this.props.insuranceName : selectedAco;
                const locationFromStorage = Cookies.get('location_' + this.props.userName);
                if (!searchParams) {
                    this.setState({
                        keyword: '', cityZip: locationFromStorage !== null && locationFromStorage !== undefined ? locationFromStorage : this.props.isCurrentLocation ? USE_CURRENT_LOCATION : !waitingOnGeoAddress ? cityAddress && stateAddress ? `${cityAddress},${stateAddress}` : '' : '', vector: '',
                        insurance: insurance, networkCode: this.props.networkCode,
                        pageNumber: 1, perPage: 12, pageNumberLocations: 1, perPageLocations: 12, searchParams: null, searchForVideoVisit: false, radius: null
                    });
                }
                else {
                    const { keyword, cityZip } = this.state;
                    if (!keyword && !cityZip && searchParams && (searchParams.keyword && searchParams.location)) {
                        let location = searchParams.location;
                        if (searchParams.isMappedArea) {
                            location = USE_MAPPED_AREA_LOCATION;
                        }
                        else if (searchParams.isCurrentLocation) {
                            location = USE_CURRENT_LOCATION;
                        }
                        this.setState({
                            keyword: getValue('keyword', false, '', searchParams),
                            cityZip: location,
                            insurance: getValue('insurance', false, insurance, searchParams),
                            vector: getValue('vector', false, 'unified', searchParams),
                            activeTab: getValue('tab', false, '1', searchParams),
                            searchParams,
                            pageNumber: getValue('pageNumber', false, 1, this.props.searchModel),
                            pageNumberLocations: getValue('pageNumber', false, 1, this.props.locationsSearchModel)
                        }, () => this.searchProvidersAndLocations(false));
                    }
                }
            }
        });
        if (this.state.cityZip && this.state.cityZip.split(',').length === 2) {
            const isLatLongInLocation = this.isLatLongInLocation(this.state.cityZip);
            if (isLatLongInLocation) {
                this.setState({ cityZip: isLatLongInLocation });
            }
        }

        if (this.state.searchOnMount === true || this.state.urgentCareModel !== null) {
            const clearSearch = this.state.searchOnMount && this.state.searchParams ? true : false;
            this.searchProvidersAndLocations(clearSearch);
        }

        const scheduleCampaignActivity = this.state.scheduleCampaignReferrer ? { scheduleCampaignReferrer: this.state.scheduleCampaignReferrer } : {};
        logUI("MBHWeb.UI.FindCare.ComponentDidMount", new Date(), Tools.getURLPath(), scheduleCampaignActivity, this.state.isVaccineSearch ? 'isVaccineSearch' : '');
        if (this.state.isVaccineSearch && enableCovidScheduleAuthFeature && currentUser) {
            logUI(`MBHWeb.UI.FindCare.VaccineSearch.AuthorizedFeature.${isCovidVaxScheduleEligible ? "Eligible" : "NotEligible"}`, new Date(), Tools.getURLPath());
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { aco, cityAddress, stateAddress, waitingOnGeoAddress } = this.props;
        const locationFromStorage = Cookies.get('location_' + this.props.userName);
        if (typeof aco !== 'undefined' && aco !== '' && this.acoAlliance === null) {//check for empty string
            this.acoAlliance = this.getAcoAlliance();
            //comment out code due to running auto search if come back from other component.
            //this.searchProvidersAndLocations();
        }
        if (prevProps.cityAddress === undefined && prevProps.stateAddress === undefined && this.props.cityAddress && this.props.stateAddress && (prevProps.waitingOnGeoAddress === undefined || prevProps.waitingOnGeoAddress) && this.props.waitingOnGeoAddress === false && (locationFromStorage === undefined || locationFromStorage === null))
            this.setState({ cityZip: `${cityAddress},${stateAddress}` });

        if (this.state.cityZip === USE_CURRENT_LOCATION && !this.props.isCurrentLocation && !this.isCurrentGeoLoc && !this.props.waitingOnGeoLocation) {
            let cityZip = "";
            if (locationFromStorage) {
                if (locationFromStorage === USE_CURRENT_LOCATION) {
                    cityZip = USE_CURRENT_LOCATION;
                    this.props.getGeoLocation(true);
                    this.isCurrentGeoLoc = true;
                }
                else {
                    cityZip = locationFromStorage;
                }
            }
            else {
                cityZip = !waitingOnGeoAddress ? cityAddress && stateAddress ? `${cityAddress},${stateAddress}` : '' : '';

            }
            this.setState({
                cityZip
            });
        }
        if (this.state.cityZip !== prevState.cityZip && this.state.cityZip !== USE_MAPPED_AREA_LOCATION) {
            this.setState({ isMappedArea: false });
        }
    }

    componentWillUnmount() {

        this.props.clearSearch();
        if (this.historyUnlisten) {
            this.historyUnlisten();
        }
    }

    isVaccineCheck() {
        return window && window.location && window.location.pathname && window.location.pathname === "/findcare/vaccine" ? true : false;
    }

    getAcoAlliance() {
        const { aco } = this.props;
        return typeof aco !== 'undefined' ? aco : null;
    }

    setActiveTab(tab) {
        this.setState({ activeTab: tab });
    }

    onUserSetActiveTab(tab) {
        this.setActiveTab(tab);
        this.updateUrl({ tab });
    }

    resetRadius(value) {
        if (value) {// && this.state.isMappedArea) {
            this.setState({ radius: value });
        } else {
            this.setState({ radius: null });
        }
    }

    nextPage(pageNum, filters) {
        // run search with new page number, do not reset state.       
        this.setState({ pageNumber: pageNum, mainSearch: true }, () => {
            this.searchProviders(filters);
        });
    }

    nextPageLocations(pageNum, filters) {
        // run search with new page number, do not reset state.
        this.setState({ pageNumberLocations: pageNum, mainSearch: true }, () => {
            this.searchLocations(filters);
        });
    }

    isLatLongInLocation(loc) {
        const validloc = loc.split(',');
        if (validloc[0].indexOf('.') !== -1 && validloc[1].indexOf('.') !== -1) {
            const searchParams = (this.props.history && this.props.history.location.search) ? queryString.parse(this.props.history.location.search)
                : this.props.history.location.searchParms ? queryString.parse(this.props.history.location.searchParms) : null;
            if (searchParams && searchParams.isMappedArea) {
                this.setState({ radius: searchParams.radius });
                return USE_MAPPED_AREA_LOCATION;

            } else {
                return USE_CURRENT_LOCATION;
            }
        }
        else
            return loc;
    }

    setLocationInCaseOfLatLng(model) {
        if (model && model.location) {
            const locationParts = model.location.split(',');
            if (locationParts.length === 2) {
                const location = this.isLatLongInLocation(model.location);
                if (location === USE_CURRENT_LOCATION) {
                    model.isCurrentLocation = true;
                }
                else if (location === USE_MAPPED_AREA_LOCATION) {
                    model.isMappedArea = true;
                }
            }
        }
    }

    handleTypeAheadRules(clearSearch, useSmartResults) {
        const { searchModel, locationsSearchModel } = this.props;
        if (this.isSameVector('locationType')) {
            this.searchLocations({ isClearList: true }, clearSearch ? null : locationsSearchModel);
        } else {
            this.searchProviders(null, clearSearch || useSmartResults ? null : searchModel);
            this.searchLocations(null, clearSearch || useSmartResults ? null : locationsSearchModel);
        }
    }

    splitMammographySearchTerms = (mammographySearchTerms) => {
        return mammographySearchTerms?.split(',');
    }

    isMammographySearchTermPresent = (keyword, mammographySearchTerms) => {
        if (mammographySearchTerms && mammographySearchTerms.length) {
            const mammoTerms = mammographySearchTerms.toString().replaceAll('&#x27;', '\'').toLowerCase();
            const mammographyTerms = this.splitMammographySearchTerms(mammoTerms);
            return mammographyTerms.indexOf(keyword) >= 0;
        }
        return false;
    }

    isMammoSearch(searchKeyword) {
        const mammographySearchTerms = this.splitMammographySearchTerms(this.props.serverData.MammographySearchTerms);
        const keyword = searchKeyword ? searchKeyword.toLowerCase() : '';
        const isTermPresent = this.isMammographySearchTermPresent(keyword, mammographySearchTerms);

        if (keyword && isTermPresent) {
            return true;
        }
        return false;
    }

    setActiveTabDependOnRule() {
        let activeTab = '1';
        const { serverData } = this.props;
        const enableFindCareNewSearchTerms = serverData && serverData.enableFindCareNewSearchTerms ? serverData.enableFindCareNewSearchTerms : false;
        const { keyword } = this.state;
        const keywordSearched = keyword ? keyword.toLowerCase() : '';
        const mammographySearchTerms = this.splitMammographySearchTerms(serverData.MammographySearchTerms);
        const isTermPresent = this.isMammographySearchTermPresent(keywordSearched, mammographySearchTerms);

        if ((this.isSameVector('locationType') || this.isSameVector('location')) || (keywordSearched && isTermPresent && enableFindCareNewSearchTerms)) {
            activeTab = '2';
        }
        this.setActiveTab(activeTab);
        return activeTab;
    }

    isSameVector(name) {
        if (this.state.vector && this.state.vector.toLowerCase() === name.toLowerCase()) {
            return true;
        }
        return false;
    }

    handleUrgentCare() {
        //Reset the urgent care value
        if (this.state.isUrgentCare) {
            this.setState({
                availability: "",
                isUrgentCare: false
            });
        }


    }

    getLatLongFromUrgentCare() {
        const searchParms = this.props.location && this.props.location.searchParms ? queryString.parse(this.props.location.searchParms) : this.props.location && this.props.location.search ? queryString.parse(this.props.location.search) : "";
        if (searchParms && searchParms.isUrgentCare && searchParms.location && searchParms.location.split(',').length === 2) {
            const validloc = searchParms.location.split(',');
            if (validloc[0].indexOf('.') !== -1 && validloc[1].indexOf('.') !== -1) {
                return [validloc[0], validloc[1]];
            }
        }
        return null;
    }

    updateUrl(obj) {
        const { history, pathname } = this.props;
        const searchParams = { ...this.state.searchParams, ...obj };
        if (searchParams.sortBy === 'Distance' && !searchParams.location) {
            searchParams.sortBy = '';
        }
        const isVaccineSearch = this.isVaccineCheck();
        //if this is a vaccine search, do not use insurance in the search params or url params
        if (isVaccineSearch) {
            delete searchParams.insurance;
        }
        const search = queryParams(searchParams);
        //if (!isVaccineSearch) {
        history.push({ pathname, search });
        //}
        this.setState({ searchParams });
    }

    getLocationQueryStringParam = () => {
        const { latitude, longitude } = this.props;
        const { cityZip, mappedAreaLocation } = this.state;
        let locationQueryString = "";
        if (cityZip === USE_CURRENT_LOCATION) {
            if (latitude && longitude) {
                locationQueryString = latitude + ',' + longitude;
            }
            else if (this.latitudeFromUrgentCare && this.longitudeFromUrgentCare) {
                locationQueryString = this.latitudeFromUrgentCare + ',' + this.longitudeFromUrgentCare;
            }
            else
                locationQueryString = '';
        }
        else if (cityZip === USE_MAPPED_AREA_LOCATION) {
            if (mappedAreaLocation && mappedAreaLocation.latitude && mappedAreaLocation.longitude) {
                locationQueryString = mappedAreaLocation.latitude + ',' + mappedAreaLocation.longitude;
            }
            else if (this.latitudeFromUrgentCare && this.longitudeFromUrgentCare) {
                locationQueryString = this.latitudeFromUrgentCare + ',' + this.longitudeFromUrgentCare;
            }
            else
                locationQueryString = '';
        }
        else
            locationQueryString = cityZip;

        return locationQueryString;
    }

    isACOEligibility(ins) {
        let isEligibility = false;
        if (ins && this.acoAlliance) {
            let acoAlliance = this.acoAlliance.split(",");
            let ACOItem = Tools.getACOs().find(a => a.label.toLowerCase() === ins.toLowerCase() && (acoAlliance && acoAlliance.indexOf(a.id) > -1));
            if (ACOItem && ACOItem.label) {
                isEligibility = true;
                //Check if needs to update selectedAco
                if (this.state.selectedAco !== ACOItem.label) {
                    this.setState({ selectedAco: ACOItem.label });
                }
            }
        }
        return isEligibility;
    }

    searchProviders(filters, searchModel) {
        const { hasAAL, serverData, currentMyChartUser } = this.props;
        let locationQueryString = this.getLocationQueryStringParam();
        const { searchParams } = this.state;
        const isVaccineSearch = this.isVaccineCheck();
        const enableVaccineScheduling = serverData && serverData.enableCOVID19VaccineScheduling ? serverData.enableCOVID19VaccineScheduling : false;
        let isLatestCall = false;

        if (!searchModel || (this.state.keyword && this.state.keyword.toLowerCase() === 'urgent care' && this.state.overrideRules === false)) {
            // search parameters common to both provider and location search...        
            searchModel = {
                keyword: this.state.keyword,
                vectorName: this.state.vector,
                insuranceCarrier: this.state.insurance,
                pageNumber: this.state.pageNumber,
                perPage: this.state.perPage,
                sortSeed: this.state.sortSeed,
                sortBy: searchParams && searchParams.sortBy ? searchParams.sortBy : '',
                overrideRules: this.state.overrideRules //apply default override, we can ignore this as well if it is fine.
            };
        }

        if (locationQueryString && locationQueryString.trim()) {
            searchModel.location = locationQueryString.trim();
        }


        if (this.props.networkCode && this.props.networkCode !== null && this.state.insurance && this.props.insuranceName &&
            this.state.insurance.toLowerCase() === this.props.insuranceName.toLowerCase()) {
            searchModel.networkCode = this.props.networkCode;
            if (this.acoAlliance) searchModel.ACOAlliance = this.acoAlliance;
        } else {
            if (this.isACOEligibility(this.state.insurance)) {
                searchModel.ACOAlliance = this.acoAlliance;
            }
        }

        if (this.state.searchForVideoVisit) {
            searchModel.visitType = "Video Visit";
        }

        //We are setting up only in first time while in urgent care
        if (this.state.urgentCareModel) {
            if (this.state.urgentCareModel.keyword) searchModel.keyword = this.state.urgentCareModel.keyword;
            if (this.state.urgentCareModel.vector) searchModel.vectorName = this.state.urgentCareModel.vector;
            //  if (this.state.urgentCareModel.visitType) searchModel.visitType = this.state.urgentCareModel.visitType;
            //if (this.state.urgentCareModel.availability) searchModel.availability = this.state.urgentCareModel.availability;
            //if (this.state.urgentCareModel.usesMyBSWHealth && this.props.usesMyBSWHealth) searchModel.usesMyBSWHealth = this.state.urgentCareModel.usesMyBSWHealth;
            //if (this.state.urgentCareModel.distance) searchModel.distance = this.state.urgentCareModel.distance;
            //if (this.state.urgentCareModel.sortBy) searchModel.sortBy = this.state.urgentCareModel.sortBy;
        }

        //Setting this item due to back search from scheduling.
        if (this.state.searchParams !== null && this.state.searchParams.visitType && this.state.searchParams.state && this.state.searchParams.state.toLowerCase() === "scheduling") searchModel.visitType = this.state.searchParams.visitType;

        if (filters) {
            //alert("inside filters");
            if (filters.isClearList) {
                this.setActiveTab('1');
                this.handleUrgentCare();
                this.props.clearProviders();
                this.props.clearLocationsResults();
            }
            else if ((this.state.keyword && this.state.keyword.toLowerCase() !== 'urgent care') || this.state.overrideRules === true) {
                // include only filter values that are appropriate for providers...
                if (filters.isPrimaryCare.value || !filters.isPrimaryCareAppliedFilter.value) {
                    searchModel.isPrimaryCare = filters.isPrimaryCare.value ? filters.isPrimaryCare.value : false;
                }
                if (filters.isSpecialtyCare.value) searchModel.isSpecialtyCare = filters.isSpecialtyCare.value;
                if (this.props.usesMyBSWHealth !== null || filters.usesMyBSWHealth.value || !filters.usesMyBSWHealthAppliedFilter.value) {
                    searchModel.usesMyBSWHealth = filters.usesMyBSWHealth.value ? filters.usesMyBSWHealth.value : false;
                }
                if (filters.gender && filters.gender.value !== 'Any') searchModel.gender = filters.gender.value;
                if (filters.specialties.value && filters.specialties.value.length) searchModel.specialty = filters.specialties.value.join('|');
                if (filters.openScheduling.value) searchModel.openScheduling = filters.openScheduling.value;
                if (filters.acceptingNewPatient.value) searchModel.acceptingNewPatient = filters.acceptingNewPatient.value;
                if (filters.ageGroupsSeen.value) searchModel.ageGroupsSeen = filters.ageGroupsSeen.value;
                if (filters.sortBy.value) searchModel.sortBy = filters.sortBy.value;
                if (filters.languages.value && filters.languages.value.length) searchModel.language = filters.languages.value.join('|');

                if (filters.visitType.value && filters.visitType.value !== -1) {
                    searchModel.visitType = filters.visitType.value;
                }
                else {
                    if (this.state.searchForVideoVisit) {
                        delete searchModel.visitType;
                        // dissable auto video visit filter after user toggle it
                        this.setState({
                            searchForVideoVisit: false
                        })
                    }
                }
                if (filters.availability.value !== undefined && filters.availability.value !== -1) searchModel.availability = filters.availability.value;
                if (filters.distance.value) searchModel.distance = filters.distance.value;
            }
        }
        else {
            // this is the case if user manually deselect usesMyBSWHealth filter and research it via enter or search button
            if (this.props.usesMyBSWHealth !== null && ((this.state.keyword && this.state.keyword.toLowerCase() !== 'urgent care') || this.state.overrideRules === true)) searchModel.usesMyBSWHealth = this.props.usesMyBSWHealth;
            // if isMappedArea is still true during the Search Click and any distance selected during last search (user has not changed the distance from dropdown), then set the distance equal to the distance last selected
            if (this.state.isMappedArea && this.state.radius && this.distanceSelectedByMappedArea) {
                searchModel.distance = this.state.radius.toLowerCase() === "radius" ? this.distanceSelectedByMappedArea : this.state.radius;
            }

            //Add this rule if user comes from video visit options with specialty.
            if (searchParams && searchParams.specialty && searchModel) {
                searchModel.specialty = searchParams.specialty;
            }

            //Default Value for distance
            if (this.state.keyword) {
                searchModel.distance = searchParams && searchParams.distance ? searchParams.distance : (this.state.keyword.toLowerCase() === 'urgent care' || this.state.searchForVideoVisit || this.isMammoSearch(this.state.keyword)) ? '25' : '10';
            }
        }

        const { insurance, radius } = this.state;
        const { vectorName, keyword, distance, sortBy } = searchModel;
        const isMappedArea = this.state.isMappedArea || (this.state.searchParams && this.state.searchParams.isMappedArea);
        const urlParams = {
            vector: vectorName, keyword: encodeURIComponent(keyword), insurance: encodeURIComponent(insurance),
            location: locationQueryString ? locationQueryString : searchParams && searchParams.location ? searchParams.location : ''
        };

        if (distance && this.state.cityZip && this.state.cityZip.trim()) {
            urlParams.distance = distance;
        }
        else {
            urlParams.distance = '';
            if (this.state.keyword && this.state.keyword.toLowerCase() !== 'urgent care') {
                this.isMammoSearch(this.state.keyword) ? searchModel.distance = '25' : searchModel.distance = '10';
            }
        }

        if (sortBy) {
            urlParams.sortBy = sortBy;
        }
        else {
            searchModel.sortBy = (this.state.cityZip !== '' && (this.state.keyword.toLowerCase() === 'urgent care' ||
                this.isMammoSearch(this.state.keyword))) ? 'Distance' : 'NextAvailableAppointment';
        }

        if (isMappedArea) {
            urlParams.isMappedArea = isMappedArea;
            urlParams.radius = radius;
        } else {
            urlParams.isMappedArea = false;
            urlParams.radius = false;
        }
        this.updateUrl(urlParams);

        if (hasAAL && serverData && serverData.enableAA)
            searchModel.lineOfBusiness = "BSWAA";

        if (!isVaccineSearch) {
            if (serverData && serverData.enableV3SearchForAllProviders) {
                if (this.isMammoSearch(this.state.keyword)) {
                    isLatestCall = false;
                } else {
                    isLatestCall = true;
                }
            } else {
                isLatestCall = false;
            }
            this.props.searchProviders(searchModel, this.onSearchProvidersComplete, isLatestCall); // this.state.updateFacets);
            logUI("MBHWeb.Search.Provider", new Date(), Tools.getURLPath(), searchModel, '');
        } else {
            let isMinor = currentMyChartUser && currentMyChartUser.ageYears && currentMyChartUser.ageYears <= 17 ? true : false;
            let dtStart = new Date();
            let { CovidVaccineSlotsInDays: noOfDays = 28 } = serverData || {};
            let dtEnd = Tools.addDays(dtStart, noOfDays);
            let startDateStr = `${dtStart.getFullYear()}-${dtStart.getMonth() + 1}-${dtStart.getDate()}`;
            let endDateStr = `${dtEnd.getFullYear()}-${dtEnd.getMonth() + 1}-${dtEnd.getDate()}`;
            const genericSearchModel = {
                startDate: startDateStr,
                endDate: endDateStr,
                location: searchModel.location,
                radius: radius || searchModel.distance,
                sortBy: searchModel.sortBy,
                visitTypeId: (serverData.enableCOVID19Booster && this.state.searchParams) ? this.state.searchParams.visitType ? this.state.searchParams.visitType : null : isMinor ? serverData.covid19VaccineVisitTypeIdForMinor : serverData.covid19VaccineVisitTypeId,
                page: this.state.pageNumber,
                perPage: this.state.perPage
            };

            if (enableVaccineScheduling) {
                this.props.searchGenericProviders(genericSearchModel, this.onSearchProvidersComplete);
            }
            logUI("MBHWeb.Search.Provider", new Date(), Tools.getURLPath(), genericSearchModel, 'isVaccineSearch');
        }
    }

    searchLocations(filters, searchModel) {
        const isVaccineSearch = this.isVaccineCheck();
        if (isVaccineSearch) return;
        const { searchParams } = this.state;
        const { hasAAL, serverData } = this.props;
        let locationQueryString = this.getLocationQueryStringParam();

        if (!searchModel || (this.state.keyword && this.state.keyword.toLowerCase() === 'urgent care' && this.state.overrideRules === false)) {
            searchModel = {
                keyword: this.state.keyword,
                vectorName: this.state.vector,
                pageNumber: this.state.pageNumberLocations,
                perPage: this.state.perPageLocations,
                sortSeed: this.state.sortSeedLocations,
                overrideRules: this.state.overrideRules //apply default override, we can ignore this as well if it is fine.
            };
        }

        if (locationQueryString && locationQueryString.trim()) {
            searchModel.location = locationQueryString.trim();
        }

        // quick fix: the vector "provider" might be forced by the bugfix in searchProvidersAndLocation
        if (searchModel.vectorName === "provider") {
            searchModel.vectorName = "unified";
        }

        //Setting doc filters if any
        if (this.state.insurance && this.state.insurance !== null && this.state.insurance !== "") {
            searchModel.insuranceCarrier = this.state.insurance;
            searchModel.docInsuranceCarrier = this.state.insurance;

            if (this.props.networkCode && this.props.networkCode !== null && this.props.insuranceName &&
                this.state.insurance.toLowerCase() === this.props.insuranceName.toLowerCase()) {
                searchModel.networkCode = this.props.networkCode;
                if (this.acoAlliance) searchModel.ACOAlliance = this.acoAlliance;
            } else {
                if (this.isACOEligibility(this.state.insurance)) {
                    searchModel.ACOAlliance = this.acoAlliance;
                }
            }
        }

        //We are setting up only in first time
        if (this.state.urgentCareModel) {
            //if (this.state.urgentCareModel.locPerks) searchModel.Perks = this.state.urgentCareModel.locPerks;
            //    if (this.state.urgentCareModel.locationType) searchModel.locationType = this.state.urgentCareModel.locationType;

            //We are setting up only in first time while in urgent care
            if (this.state.urgentCareModel.keyword) searchModel.keyword = this.state.urgentCareModel.keyword;
            if (this.state.urgentCareModel.vector) searchModel.vectorName = this.state.urgentCareModel.vector;
            // if (this.state.urgentCareModel.visitType) searchModel.docVisitType = this.state.urgentCareModel.visitType;
            //if (this.state.urgentCareModel.availability) searchModel.docAvailability = this.state.urgentCareModel.availability;
            //if (this.state.urgentCareModel.usesMyBSWHealth && this.props.usesMyBSWHealth) searchModel.docUsesMyBSWHealth = this.state.urgentCareModel.usesMyBSWHealth;
            //if (this.state.urgentCareModel.distance) searchModel.distance = this.state.urgentCareModel.distance;
            //if (this.state.urgentCareModel.locationSortBy) searchModel.sortBy = this.state.urgentCareModel.locationSortBy;
        }

        //Setting this item due to back search from scheduling.
        if (this.state.searchParams !== null && this.state.searchParams.visitType && this.state.searchParams.state && this.state.searchParams.state.toLowerCase() === "scheduling") searchModel.docVisitType = this.state.searchParams.visitType;

        if (filters) {
            if (filters.isClearList) {
                this.setActiveTab('2');
                this.handleUrgentCare();
                this.props.clearProviders();
                this.props.clearLocationsResults();
            }
            else if ((this.state.keyword && this.state.keyword.toLowerCase() !== 'urgent care') || this.state.overrideRules === true) {
                if (filters.locationSortBy.value) {
                    searchModel.sortBy = filters.locationSortBy.value;
                }

                // include only filter values that are appropriate for facilities...
                //if (filters.sortBy.value) searchModel.sortBy = filters.sortBy.value;
                if (filters.sortBy.value) searchModel.docSortBy = filters.sortBy.value;
                if (filters.locationSpecialties.value && filters.locationSpecialties.value.length) searchModel.specialties = filters.locationSpecialties.value.join('|');
                if (filters.locationPerks.value && filters.locationPerks.value.length) searchModel.perks = filters.locationPerks.value.join('|');
                if (filters.locationOpenNow.value) searchModel.openNow = filters.locationOpenNow.value;
                if (filters.locationOpenBefore8.value) searchModel.openBefore8 = filters.locationOpenBefore8.value;
                if (filters.locationOpenAfter5.value) searchModel.openAfter5 = filters.locationOpenAfter5.value;
                if (filters.locationOpenWeekends.value) searchModel.openWeekends = filters.locationOpenWeekends.value;
                if (filters.locationTypes.value && filters.locationTypes.value.length) searchModel.locationType = filters.locationTypes.value.join('|');
                if (filters.locationServices.value && filters.locationServices.value.length) searchModel.services = filters.locationServices.value.join('|');
                if (filters.distance.value) searchModel.distance = filters.distance.value;

                // include filter values that are appropriate for doctors also...
                if (filters.isPrimaryCare.value || !filters.isPrimaryCareAppliedFilter.value) searchModel.docIsPrimaryCare = filters.isPrimaryCare.value ? filters.isPrimaryCare.value : false;
                if (filters.isSpecialtyCare.value) searchModel.docIsSpecialityCare = filters.isSpecialtyCare.value;
                if (filters.gender.value && filters.gender.value !== 'Any') searchModel.docGender = filters.gender.value;
                if (filters.languages.value && filters.languages.value.length) searchModel.docLanguage = filters.languages.value.join('|');
                if (filters.specialties.value && filters.specialties.value.length) searchModel.docSpeciality = filters.specialties.value.join('|');
                if (filters.acceptingNewPatient.value) searchModel.docAcceptingNewPatient = filters.acceptingNewPatient.value;

                if (this.props.usesMyBSWHealth !== null || filters.usesMyBSWHealth.value || !filters.usesMyBSWHealthAppliedFilter.value) {
                    searchModel.docUsesMyBSWHealth = filters.usesMyBSWHealth.value ? filters.usesMyBSWHealth.value : false;
                }
                if (filters.ageGroupsSeen.value) searchModel.docAgeGroupsSeen = filters.ageGroupsSeen.value;
                if (filters.availability.value !== undefined && filters.availability.value !== -1) searchModel.docAvailability = filters.availability.value;
                if (filters.openScheduling.value) searchModel.docOpenScheduling = filters.openScheduling.value;
                if (filters.visitType.value && filters.visitType.value !== -1) searchModel.docVisitType = filters.visitType.value;
            }

            if (filters.isClearList) {
                const { insurance } = this.state;
                const { vectorName, keyword, sortBy, distance } = searchModel;
                const urlParams = {
                    vector: vectorName, keyword: encodeURIComponent(keyword), insurance: encodeURIComponent(insurance),
                    location: locationQueryString ? locationQueryString : ''
                };
                if (sortBy) urlParams.sortBy = sortBy;
                if (distance) urlParams.distance = distance;
                this.updateUrl(urlParams);
            }
        }
        else {
            if (this.props.usesMyBSWHealth !== null && ((this.state.keyword && this.state.keyword.toLowerCase() !== 'urgent care') || this.state.overrideRules === true)) searchModel.docUsesMyBSWHealth = this.props.usesMyBSWHealth;

            if (this.state.keyword) {
                searchModel.distance = searchParams && searchParams.distance ? searchParams.distance : (this.state.keyword.toLowerCase() === 'urgent care' || this.state.searchForVideoVisit || this.isMammoSearch(this.state.keyword)) ? '25' : '10';
            }

            if (this.state.isMappedArea && this.state.radius && this.distanceSelectedByMappedArea) {
                searchModel.distance = this.state.radius.toLowerCase() === "radius" ? this.distanceSelectedByMappedArea : this.state.radius;
            }
        }

        if (this.state.mapList) {
            this.setState({ mapList: null });
        }

        if (!searchModel.sortBy) {
            searchModel.sortBy = this.state.cityZip !== '' ? 'Distance' : 'NextAvailableAppointment';
        }

        if (hasAAL && serverData && serverData.enableAA)
            searchModel.lineOfBusiness = "BSWAA";

        this.props.searchLocations(searchModel, this.onSearchLocationsComplete/*, this.state.updateFacets*/);
        logUI("MBHWeb.Search.Locations", new Date(), Tools.getURLPath(), searchModel, this.state.isVaccineSearch ? 'isVaccineSearch' : '');
    }

    searchProvidersAndLocations(clearSearch, useSmartResults = false) {
        let forceVector = "unified";
        let kwd = this.state.keyword.trim().toLowerCase();

        if (clearSearch) {
            this.props.clearProviders();
            this.updateUrl({ tab: this.setActiveTabDependOnRule() });
        }

        this.props.clearProviderDetail();
        this.handleUrgentCare();

        if (this.state.keyword && this.state.keyword.toLowerCase() === "urgent care") {
            this.setActiveTab('2');
            this.updateUrl({ tab: '2' });
        }

        const skipLocationSave = this.state.searchOnMount && this.state.searchParams && this.state.searchParams.location === '';
        const smartQueryFilters = this.props.smartResponseResults?.smartQueryFilters;
        const defaultDistance = (this.state.keyword.toLowerCase() === 'urgent care' || this.state.searchForVideoVisit || this.isMammoSearch(this.state.keyword) || this.state.isVaccineSearch) ? '25' : '10';
        const issearchOnMount = this.state.searchOnMount;
        const { searchParams, radius } = this.state;
        this.setState({
            pageNumber: clearSearch ? 1 : this.state.pageNumber,
            pageNumberLocations: clearSearch ? 1 : this.state.pageNumberLocations,
            sortSeed: Math.floor(Math.random() * 10000),
            searchOnMount: false,
            clearFilters: clearSearch && this.state.urgentCareModel === null,
            urgentCareModel: clearSearch ? null : this.state.urgentCareModel,
            mapList: null,
            overrideRules: false,
            insurance: useSmartResults ? smartQueryFilters.insuranceCarrier ?? '' : this.state.insurance ? this.state.insurance : '',
            radius: useSmartResults ? smartQueryFilters.distance.toString() : issearchOnMount ? radius && radius : defaultDistance,
            searchParams: {
                ...this.state.searchParams, distance: useSmartResults ? smartQueryFilters.distance : issearchOnMount ? searchParams && searchParams.distance : defaultDistance
            }
        }, () => {
            this.handleTypeAheadRules(clearSearch, useSmartResults);
            if (typeof window !== "undefined")
                Tools.setItemToSessionStorage('insurance_' + this.props.userName, this.state.insurance);
            const { cityAddress, stateAddress } = this.props;
            if (this.state.cityZip !== `${cityAddress},${stateAddress}` && this.state.cityZip !== USE_CURRENT_LOCATION && this.state.cityZip !== USE_MAPPED_AREA_LOCATION && !skipLocationSave)
                Cookies.set('location_' + this.props.userName, this.state.cityZip, { domain: Tools.getDomain(location.href) });
            if (this.state.cityZip === USE_CURRENT_LOCATION && !skipLocationSave) {
                if (this.props.latitude && this.props.longitude) {
                    Cookies.set('location_' + this.props.userName, this.state.cityZip, { domain: Tools.getDomain(location.href) });
                } else {
                    if (typeof Cookies.get('location_' + this.props.userName) !== "undefined" && Cookies.get('location_' + this.props.userName)) Cookies.expire('location_' + this.props.userName, { domain: Tools.getDomain(location.href) });
                }
            }

        });
    }

    onSearchProvidersComplete(providerList) {
        if (this.state.searchParams !== null && this.state.searchParams.isUrgentCare) {
            this.setState({ isUrgentCare: true/*,searchParams: null*/ });
        }
        // this is perhaps added in the past for some scenario required when redirecting from scheduling
        //} else if (this.state.searchParams !== null && this.state.searchParams.state) {
        //    this.setState({ searchParams: null });
        //}

        //Navigate to provider details page. 
        if (this.state.vector && this.state.vector === "provider" && providerList && providerList.providerResults && providerList.providerResults.length === 1) {
            this.props.history.push("/providers/" + providerList.providerResults[0].provider.npi);
        }

        this.onSearchComplete();
        logUI("MBHWeb.Search.Completed", new Date(), Tools.getURLPath(), providerList, this.state.isVaccineSearch ? 'isVaccineSearch' : '');
    }

    onSearchLocationsComplete = () => {
        this.onSearchComplete();
    }

    onSearchComplete() {
        const { searchRunning, searchLocationsRunning, providers, locations } = this.props;
        const { searchParams } = this.state;
        const isVaccineSearch = this.isVaccineCheck();
        if (!searchRunning && !searchLocationsRunning) {
            const mapList = [];

            if (this.state.activeTab === '1') {
                getMapListOfProviders(providers, mapList);
                if (!isVaccineSearch)
                    getMapListOfLocations(locations, mapList);
            }
            else {
                getMapListOfLocations(locations, mapList);
                if (!isVaccineSearch)
                    getMapListOfProviders(providers, mapList);
            }

            if (this.state.keyword && this.state.keyword.toLowerCase() === "urgent care" && !(locations && locations.length > 0)) {    //Task 34118.
                let activeTab = providers && providers.length > 0 ? '1' : '2';
                this.setActiveTab(activeTab);
                this.updateUrl({ tab: activeTab });
            }

            if (!(providers && providers.length > 0) && (locations && locations.length > 0)) {
                this.setActiveTab('2');
                this.updateUrl({ tab: '2' });
            }

            groupByLocation(mapList);
            this.setState({ mapList });
        }
    }

    getMappedAreaSearchResults(filters, mappedArea) {
        this.distanceSelectedByMappedArea = mappedArea.distance ? mappedArea.distance : null;
        this.setState({
            cityZip: USE_MAPPED_AREA_LOCATION,
            mappedAreaLocation: mappedArea.location,
            radius: 'Radius',
            bounds: mappedArea.bounds,
            isMappedArea: true,
            overrideRules: true
        }, () => {
            this.searchProviders(filters);
            this.searchLocations(filters);
        });
    }

    applyFilters(filters, searchType) {
        // update store value for usesMyBSWHealth so when next time user comes to same page find-care
        // it will used last selected useMyBSWHealth filter
        // if usesMyBSWHealthAppliedFilter is true but usesMyBSWHealth is false then we have to take usesMyBSWHealth value.
        if (filters && (!filters.usesMyBSWHealthAppliedFilter.value || !filters.usesMyBSWHealth.value) && this.props.usesMyBSWHealth !== filters.usesMyBSWHealth.value) {
            this.props.updateUsesMyBSWHealth(filters.usesMyBSWHealth.value);
        }

        const isSameVector = this.isSameVector('locationType');

        if (this.state.overrideRules === false) {
            this.setState({ overrideRules: true });
        }

        if (!searchType) {
            this.setState({ pageNumber: 1, pageNumberLocations: 1, urgentCareModel: null }, () => {
                if (!isSameVector) {
                    this.searchProviders(filters, null);
                }
                this.searchLocations(filters);
            });
        }
        else if (searchType === 'provider') {
            this.setState({ pageNumber: 1, urgentCareModel: null }, () => {
                if (!isSameVector) {
                    this.searchProviders(filters, null);
                }
            });
        }
        else if (searchType === 'location') {
            this.setState({ pageNumberLocations: 1, urgentCareModel: null }, () => {
                this.searchLocations(filters);
            });
        }
        this.setState({ mainSearch: true });
    }

    onCityZipChange(val) {
        //this.resetRadius();
        const isMappedArea = val === USE_MAPPED_AREA_LOCATION;
        const searchParams = this.state.searchParams;
        if (searchParams) {
            searchParams.isMappedArea = isMappedArea;
            searchParams.isCurrentLocation = isMappedArea || val === USE_CURRENT_LOCATION;
        }
        this.setState({ cityZip: val, isMappedArea, searchParams });
    }

    setZoom = (booleanValue) => {
        this.zoomSet = booleanValue;
    }

    toggleModal = () => {
        Tools.setItemToSessionStorage(MammogramCovid19ModalSessionKeyInitial, true);
        this.setState({ showMammogramCovid19Modal: false });
    }

    render() {
        if (Array.isArray(this.getLatLongFromUrgentCare())) {
            const locationLatLong = this.getLatLongFromUrgentCare();
            this.latitudeFromUrgentCare = locationLatLong[0];
            this.longitudeFromUrgentCare = locationLatLong[1];
        }

        const { showCOVID19Modal, hasMyChartLogin, currentMyChartUser, userName, showVideoVisitToolTip, isCovidVaxScheduleEligible, enableCovidScheduleAuthFeature, currentUser, proxyListLoading, proxyListFailure, onlineSchedulingEnabled, screenBreakPoint } = this.props;
        this.sessionKey = currentMyChartUser && currentMyChartUser.displayName && currentMyChartUser.eid ?
            userName + '_' + currentMyChartUser.displayName + '_' + currentMyChartUser.eid : userName;
        const shouldShowCovidModal = !Tools.getItemFromSessionStorage(CovidScreeningModalSessionKeyInitial + this.sessnKey) ? true : false;
        const isVaccineSearch = this.isVaccineCheck();
        const containerClass = (!this.props.searchSucceeded ? ' find-care-home-page' : ' find-care-results-page') + (isVaccineSearch ? " find-care-loc-only" : "");
        const isDesktop = (this.props.screenBreakPoint === msgs.XL_DESKTOP || this.props.screenBreakPoint === msgs.XXL_DESKTOP) ? true : false;

        //Return to Non authorized page, if user doesn't have feature enabled.
        if (enableCovidScheduleAuthFeature && isVaccineSearch && !isCovidVaxScheduleEligible) {
            return (((proxyListLoading || !currentUser) && !proxyListFailure) ? <Spinner /> : <NotAuthorized />);
        }

        return (
            <div className={"container-fluid body-content find-care-container" + containerClass}>
                <div className="row find-care-home">
                    <Grid>
                        {(!this.props.searchSucceeded && !this.props.searchLocationSucceeded && !isVaccineSearch)
                            ? <div className="row search-intro">
                                <div className="col-12">
                                    {/* <div className="svg-find-care" /> */}
                                    {/* <h1 className="page-heading"></h1> */}
                                    <PageHeading heading="Find Care" />

                                    <Typography type="heading-02"
                                        color="$color-secondary-a2"
                                        tag="h2"
                                        textAlign="left">Search for the right doctor, location, or type of care for you.</Typography>
                                    {/* <h2 className="section-subtitle"></h2> */}
                                    {/* <h2 className="section-subtitle">Find Dr. Right<sup>®</sup>, schedule an appointment, search for same-day care near you and more.</h2> */}
                                    {/*<p>Search for things like flu vaccination, knee pain, urgent care or a physician, specialty, facility name.</p>*/}
                                </div>
                            </div>
                            : <React.Fragment>
                                {isVaccineSearch &&
                                    <div className="row find-care-vaccine-intro">
                                        <div className="col-12">
                                            <h1 className="page-heading">Where would you like to schedule this appointment?</h1>
                                        </div>
                                    </div>
                                }
                            </React.Fragment>
                        }

                        <div className="row">
                            <FindCareForm keyword={this.state.keyword}
                                setKeyword={(val) => this.setState({ keyword: val })}
                                acoAlliance={this.acoAlliance}
                                networkCode={this.props.networkCode}
                                setKeywordList={(val) => this.setState({ keywordList: val })}
                                insurance={this.state.insurance} setInsurance={(val) => this.setState({ insurance: val })}
                                userInsurancePlan={this.props.insuranceName}
                                cityZip={this.state.cityZip} setCityZip={val => this.onCityZipChange(val)} setVector={val => this.setState({ vector: val })}
                                isUrgentCare={this.state.searchParams !== null && this.state.searchParams.isUrgentCare}
                                searchProviders={this.searchProviders}
                                searchLocations={this.searchLocations}
                                searchProvidersAndLocations={() => { this.searchProvidersAndLocations(true); this.setState({ mainSearch: true, fitBounds: this.state.isMappedArea }); }}
                                currentLat={this.latitudeFromUrgentCare ? this.latitudeFromUrgentCare : this.latitude ? this.latitude : this.props.latitude}
                                currentLong={this.longitudeFromUrgentCare ? this.longitudeFromUrgentCare : this.longitude ? this.longitude : this.props.longitude}
                                getGeoLocation={(isLocation) => { this.props.getGeoLocation(isLocation); this.isCurrentGeoLoc = isLocation; }} geoLocationError={this.props.geolocationError} isCurrentLocation={this.props.isCurrentLocation}
                                loading={this.props.searchRunning || this.props.searchLocationsRunning}
                                history={this.props.history}
                                isFormOpen={this.props.searchModel && this.props.searchModel.isFormOpen}
                                onFormToggle={isFormOpen => this.props.searchModel.isFormOpen = isFormOpen}
                                hasSWHP={this.props.hasSWHP}
                                radius={this.state.radius}
                                screenBreakPoint={screenBreakPoint}
                            />
                        </div>
                    </Grid>
                </div>
                {
                    (this.props.searchRunning || this.props.searchLocationsRunning) //spinner keeps loading when acoAlliance is null
                    && <Spinner />
                }

                {
                    (this.props.searchSucceeded || this.props.searchLocationSucceeded) &&
                    <FindCareResults
                        networkCode={this.props.networkCode}
                        insurance={this.state.insurance}
                        userInsurancePlan={this.props.insuranceName}
                        pageSize={this.state.perPage}
                        pageSizeLocations={this.state.perPageLocations}
                        nextPage={this.nextPage}
                        nextPageLocations={this.nextPageLocations}
                        applyFilters={this.applyFilters}
                        mapList={this.state.mapList}
                        canSelectDistance={this.state.cityZip ? this.state.cityZip.trim() : ""}
                        providersActivePage={this.state.pageNumber}
                        locationsActivePage={this.state.pageNumberLocations}
                        activeTab={this.state.activeTab}
                        setActiveTab={activeTab => this.onUserSetActiveTab(activeTab)}
                        urgentCareModel={this.state.urgentCareModel}
                        searchParams={this.state.searchParams}
                        getMappedAreaSearchResults={this.getMappedAreaSearchResults}
                        isMappedArea={this.state.isMappedArea}
                        radius={this.state.radius}
                        resetRadius={this.resetRadius}
                        isUrgentCare={this.state.searchParams !== null && this.state.searchParams.isUrgentCare}
                        //We need to hide Search Here button in case if main search done from findcareform 
                        hideSearchHere={this.state.mainSearch}
                        setMainSearch={(value) => { this.setState({ mainSearch: value }); }}
                        searchModel={this.props.searchModel}
                        shouldShowVideoToolTip={showVideoVisitToolTip}
                        onlineSchedulingEnabled={onlineSchedulingEnabled}
                        searchRunning={this.props.searchRunning || this.props.searchLocationsRunning}
                        overrideRules={this.state.overrideRules}
                        fitBounds={this.state.fitBounds}
                        setFitBounds={(value) => { this.setState({ fitBounds: value }); }}
                        searchProvidersAndLocations={this.searchProvidersAndLocations}
                        scheduleCampaignReferrer={this.state.scheduleCampaignReferrer}
                    />
                }
                {
                    (this.props.searchErrored && this.props.searchLocationsErrored) &&
                    <div className="row">
                        <div className="col-12 maxWidth-content">
                            <SectionLoadingError message="We're not able to display results. Please try again later." />
                        </div>
                    </div>
                }

                {!isVaccineSearch && showCOVID19Modal && hasMyChartLogin && shouldShowCovidModal ? <COVIDScreeningModal shouldShowCovidModal /> : null}
            </div>
        );
    }

}

const openScheduleStart = () => {
    const dt = new Date();
    return `${dt.getFullYear()}-${dt.getMonth()}-${dt.getDate()}`;
};

const openScheduleEnd = () => {
    const dt = new Date();
    dt.setMonth(dt.getMonth() + 1);
    return `${dt.getFullYear()}-${dt.getMonth()}-${dt.getDate()}`;
};

const mapStateToProps = (state, ownProps) => {
    const healthPlanId = state.session.currentHealthPlanInfo
        && state.session.currentHealthPlanInfo.ProviderKey ? state.session.currentHealthPlanInfo.ProviderKey : '';

    const insurancePlan = state.session.insuranceName ? state.session.insuranceName :
        state.memberships.hasAnySWHP ? "Baylor Scott & White Health Plan" : state.memberships.hasFC ? "FirstCare Health Plans" : "";

    return {
        clearSearch: state.providers.clearSearch,
        providers: state.providers.providers,
        smartResponseResults: state.providers.smartResponseResults,
        searchModel: state.providers.searchModel,
        locationsSearchModel: state.locations.searchModel,
        searchRunning: state.providers.searchRunning,
        searchSucceeded: state.providers.success,
        searchErrored: state.providers.error,
        searchLocationsRunning: state.locations.searchRunning,
        searchLocationSucceeded: state.locations.success,
        searchLocationsErrored: state.locations.error,
        locations: state.locations.locations,
        latitude: state.locations.latitude,
        longitude: state.locations.longitude,
        isCurrentLocation: state.locations.isCurrentLocation,
        networkCode: state.session.networkCode,
        healthPlanId: healthPlanId,
        insuranceName: insurancePlan,
        geolocationError: state.locations.geolocationError,
        userName: state.domain.un,
        usesMyBSWHealth: state.providers.usesMyBSWHealth,
        serverData: state.session.serverData,
        aco: state.sso.userDetails.ACO,
        history: state.session.history,
        hasAAL: !state.common.aalDown && state.memberships.hasAA,
        cityAddress: state.locations.city,
        stateAddress: state.locations.state,
        waitingOnGeoAddress: state.locations.waitingOnGeoAddress,
        waitingOnGeoLocation: state.locations.waitingOnGeoLocation,
        showCOVID19Modal: state.session.serverData && state.session.serverData.showCOVID19Modal ? state.session.serverData.showCOVID19Modal : false,
        hasMyChartLogin: state.domain.hm,
        currentMyChartUser: d.hydrateProxyUser(state.domain.cu),
        showVideoVisitToolTip: state.session.showVideoVisitToolTip && state.memberships.isActiveFeature_OnlineAppointmentScheduling,
        hasSWHP: state.memberships.hasAnySWHP,
        currentUser: state.memberships.currentUser,
        proxyListLoading: state.memberships.proxyListLoading,
        proxyListFailure: state.memberships.proxyListFailure,
        isCovidVaxScheduleEligible: state.memberships.hasAuthorizedFeatureSchedCovidVax,
        enableCovidScheduleAuthFeature: state.session.serverData && state.session.serverData.enableCovidScheduleAuthFeature ? state.session.serverData.enableCovidScheduleAuthFeature : false,
        onlineSchedulingEnabled: state.memberships.isActiveFeature_OnlineAppointmentScheduling,
        screenBreakPoint: state.common.screenBreakPoint,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateSearchFacets: (updateFacets) => {
            dispatch({ type: types.UPDATE_FACETS, updateFacets });
        },
        searchProviders: (searchModel, callback, isLatestCall) => {
            dispatch({ type: types.SEARCH_PROVIDER, searchModel: searchModel, callback: callback, isLatestCall: isLatestCall });
        },
        searchLocations: (searchModel, callback) => {
            dispatch({ type: types.SEARCH_LOCATION, searchModel: searchModel, callback: callback });
        },
        clearProviders: () => dispatch({ type: types.CLEAR_PROVIDERS }),
        clearProviderDetail: () => {
            dispatch({ type: types.CLEAR_PROVIDER_DETAIL });
        },
        clearLocationsResults: () => {
            dispatch({ type: types.CLEAR_LOCATIONS_RESULTS });
        },
        getGeoLocation: (useCurrentLocation) => dispatch({ type: types.GEOLOCATION, useCurrentLocation: useCurrentLocation }),
        updateUsesMyBSWHealth: (usesMyBSWHealth) => {
            dispatch({
                type: types.UPDATE_USEMYBSWHEALTH_FILTER, usesMyBSWHealth: usesMyBSWHealth
            });
        },
        searchGenericProviders: (searchModel, callback) => {
            dispatch({ type: types.SEARCH_FOR_GENERIC_PROVIDER, searchModel: searchModel, callback: callback });
        },
        clearSearch: () => {
            dispatch({ type: types.SEARCH_PROVIDER_CLEAR });
            dispatch({ type: types.SEARCH_LOCATION_CLEAR });
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FindCare));